import styled from "styled-components";

import StatusLineWrapper from "./StatusLineWrapper.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import Body from "features/shared/styles/typography/Body.styled";

const StyledResolvedCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  height: 300px;
  min-width: 295px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  border: 2px solid #395b94;

  color: ${({ theme }) => theme.colors.base5};

  ${StatusLineWrapper} {
    background-color: #395b94;
    margin: -16px;
    padding: 16px;
    border-radius: 0;
    color: ${({ theme }) => theme.colors.baseWhite};

    ${MicroHeader} {
      color: ${({ theme }) => theme.colors.baseWhite};
    }
  }

  ${Summary} {
    font-weight: 600;
    padding-top: 16px;
  }

  ${Body} {
    font-weight: 600;
  }
`;

export default StyledResolvedCard;
